import * as React from 'react';

import { Panel } from '@shared/components/bootstrap';
import { Pluralize } from '@shared/components/helpers/pluralize';

import { Titleize } from '@admin/components/helpers/titleize';
import { IPallet } from '@admin/types/pallet';

import { QaQrCodeLink } from '../qa_automation/qa_qr_code_link';

export const PalletSection: React.FC<{
  pallet: IPallet;
}> = ({ pallet }) => (
  <Panel>
    <Panel.Body>
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'space-between' }}>
        <div>
          <div>
            <a href={`/pallets/${pallet.id}`} className="btn-link">
              #{pallet.barcode.value}
            </a>{' '}
            <strong>({pallet.state})</strong>
            <QaQrCodeLink value={pallet.barcode.value} />
          </div>
          <div>
            <Pluralize count={pallet.items.length} singular="Item" plural="Items" />
          </div>
        </div>

        {pallet.location && (
          <div>
            <div>
              <strong>
                <Titleize text={pallet.location.located.type} />:
              </strong>{' '}
              <span>{pallet.location.located.object.name}</span>
            </div>
            <div>
              <strong>Location:</strong>{' '}
              <a href={`/locations/${pallet.location.id}`} className="btn-link">
                #{pallet.location.value}
              </a>
              <QaQrCodeLink value={pallet.location.value} />
            </div>
          </div>
        )}
      </div>
    </Panel.Body>
  </Panel>
);
